import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { SettingsComponentMenuHr } from 'approot/activity-builder/settings/settings-component-menu.style';
import { SettingProps } from './column-settings.constants';
import ColumnSettingsNumberOfColumns from './column-settings-number-of-columns';
import ColumnSettingsBorders from './column-settings-borders';
import ColumnSettingAligment from './column-settings-alignment';
import { ColumnSettings } from './column-settings.style';

const ColumnsSettings = (props: SettingProps) => {
  const { contentId } = useGetInteractiveLessonParams();
  const { activeComponent } = useActivityBuilderContext();

  return (
    <ColumnSettings>
      <ColumnSettingsNumberOfColumns {...props} contentId={contentId} />
      <SettingsComponentMenuHr />
      <ColumnSettingAligment {...props} />
      <SettingsComponentMenuHr />
      <ColumnSettingsBorders
        {...props}
        selectedColumn={activeComponent?.column?.id}
        selectedComponentId={activeComponent?.id}
      />
      {activeComponent?.column?.id && <SettingsComponentMenuHr />}
    </ColumnSettings>
  );
};

export default ColumnsSettings;
